import React, { Component } from 'react';
import { HorizontalLine } from './HorizontalLine';
import Cookies from 'universal-cookie';

class PaymentPage extends React.Component {
    state = {
        loading: false,
        selectedTariff: null,
        selectedWebsites: [], // Массив выбранных сайтов
        billingPeriod: 'month',
        tarificationMethod: 'daily',
        showFreeTrialModal: false,
        showWebsiteSelectModal: false, // Модалка выбора сайтов
        websites: [], // Список доступных сайтов
        loadingWebsites: true,
        tarifs: [
            {
                id: 1,
                name: 'Начальный',
                price: 2900,
                visits: 'до 10,000',
                description: 'Посещаемость сайта до 10,000 визитов в месяц',
                popular: false,
                features: []
            },
            {
                id: 2,
                name: 'Средний',
                price: 4500,
                visits: 'от 10,000 до 30,000',
                description: 'Посещаемость сайта от 10,000 до 30,000 визитов в месяц',
                popular: true,
                features: []
            },
            {
                id: 3,
                name: 'Посещаемый',
                price: 7700,
                visits: 'от 30,000 до 60,000',
                description: 'Посещаемость сайта от 30,000 до 60,000 визитов в месяц',
                popular: false,
                features: []
            },
            {
                id: 4,
                name: 'Большой',
                price: 13500,
                visits: 'от 60,000 до 100,000',
                description: 'Посещаемость сайта от 60,000 до 100,000 визитов в месяц',
                popular: false,
                features: []
            },
            {
                id: 5,
                name: 'Великан',
                price: 23000,
                visits: 'от 100,000 до 200,000',
                description: 'Посещаемость сайта от 100,000 до 200,000 визитов в месяц',
                popular: false,
                features: []
            }
        ]
    }

    constructor(props) {
        super(props);
        this.cookies = new Cookies();
    }

    componentDidMount() {
        this.fetchWebsites();
    }

    fetchWebsites = async () => {
        try {
            const token = this.cookies.get('clickanti_token');
            
            if (!token) {
                this.setState({ 
                    loadingWebsites: false,
                    websites: []
                });
                return;
            }

            const response = await fetch('https://api.clickanti.ru/api/clickanti/websites', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Ошибка загрузки: ${response.status}`);
            }

            const data = await response.json();
            this.setState({ 
                websites: data,
                loadingWebsites: false 
            });
        } catch (error) {
            console.error('Ошибка при загрузке сайтов:', error);
            this.setState({ 
                loadingWebsites: false,
                websites: []
            });
        }
    }

    formatCurrency = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₽';
    }

    calculateYearlyPrice = (monthlyPrice) => {
        return monthlyPrice * 10;
    }

    handleTariffSelect = (tariff) => {
        this.setState({ 
            selectedTariff: tariff,
            showWebsiteSelectModal: true,
            selectedWebsites: []
        });
    }

    handleWebsiteToggle = (websiteId) => {
        this.setState(prevState => {
            const { selectedWebsites } = prevState;
            const isSelected = selectedWebsites.includes(websiteId);
            
            return {
                selectedWebsites: isSelected
                    ? selectedWebsites.filter(id => id !== websiteId)
                    : [...selectedWebsites, websiteId]
            };
        });
    }

    handleBillingPeriodChange = (period) => {
        this.setState({ billingPeriod: period });
    }

    handleStartTrial = () => {
        this.setState({ showFreeTrialModal: true });
    }

    handleSubscribe = () => {
        const { selectedTariff, selectedWebsites, billingPeriod } = this.state;
        
        if (!selectedTariff) {
            alert('Пожалуйста, выберите тариф');
            return;
        }

        if (selectedWebsites.length === 0) {
            alert('Пожалуйста, выберите хотя бы один сайт');
            return;
        }

        this.setState({ loading: true });

        // Имитация процесса оплаты
        setTimeout(() => {
            return;
            this.setState({ 
                loading: false,
                showWebsiteSelectModal: false
            });
            
            const websitesText = selectedWebsites.map(id => {
                const website = this.state.websites.find(w => w.id === id);
                return website ? website.url : '';
            }).join(', ');
            
            alert(`Вы успешно подписались на тариф "${selectedTariff.name}"!\nСайты: ${websitesText}\nСумма: ${this.formatCurrency(billingPeriod === 'year' ? this.calculateYearlyPrice(selectedTariff.price) : selectedTariff.price)}`);
        }, 1500);
    }

    closeModal = () => {
        this.setState({ showFreeTrialModal: false });
    }

    closeWebsiteSelectModal = () => {
        this.setState({ 
            showWebsiteSelectModal: false,
            selectedWebsites: []
        });
    }

    renderTarifCard = (tarif) => {
        const { selectedTariff, billingPeriod } = this.state;
        const isSelected = selectedTariff?.id === tarif.id;
        const price = billingPeriod === 'year' ? this.calculateYearlyPrice(tarif.price) : tarif.price;
        const periodText = billingPeriod === 'year' ? 'год' : 'мес';

        return (
            <div 
                key={tarif.id}
                style={{
                    background: isSelected ? '#FAFBFF' : 'white',
                    borderRadius: '1em',
                    padding: '2em',
                    border: isSelected ? '2px solid #0767F4' : '1px solid #E2ECF9',
                    boxShadow: '0 0.5em 3.5em rgba(226, 236, 249, 0.5)',
                    position: 'relative',
                    transition: 'all 0.3s',
                    cursor: 'pointer',
                    height: '100%'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
                {tarif.popular && (
                    <div style={{
                        position: 'absolute',
                        top: '-1em',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#0767F4',
                        color: 'white',
                        padding: '0.5em 1.5em',
                        borderRadius: '2em',
                        fontSize: '0.9em',
                        fontWeight: '600',
                        zIndex: 1
                    }}>
                        ПОПУЛЯРНЫЙ
                    </div>
                )}
                
                <div style={{
                    fontSize: '1.2em',
                    fontWeight: '600',
                    color: '#252733',
                    marginBottom: '0.5em'
                }}>
                    {tarif.name}
                </div>
                
                <div style={{
                    fontSize: '2.5em',
                    fontWeight: '700',
                    color: '#0767F4',
                    margin: '0.5em 0'
                }}>
                    {this.formatCurrency(price)}
                    <span style={{
                        fontSize: '0.5em',
                        color: '#9197B3',
                        fontWeight: '400'
                    }}>
                        /{periodText}
                    </span>
                </div>
                
                <div style={{
                    fontSize: '1.1em',
                    color: '#666',
                    marginBottom: '1.5em',
                    minHeight: '3em'
                }}>
                    {tarif.description}
                </div>
                
                <button 
                    onClick={() => this.handleTariffSelect(tarif)}
                    style={{
                        width: '100%',
                        padding: '1em',
                        border: 'none',
                        borderRadius: '0.5em',
                        background: isSelected ? '#0767F4' : '#F3F3F3',
                        color: isSelected ? 'white' : '#666',
                        cursor: 'pointer',
                        fontSize: '1em',
                        fontWeight: '600',
                        transition: 'all 0.3s'
                    }}
                >
                    {isSelected ? '✓ Выбран' : 'Выбрать'}
                </button>
            </div>
        );
    }

    renderWebsiteSelectModal = () => {
        const { showWebsiteSelectModal, selectedTariff, websites, loadingWebsites, selectedWebsites, billingPeriod } = this.state;

        if (!showWebsiteSelectModal) return null;

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                padding: '2em'
            }}>
                <div style={{
                    background: 'white',
                    borderRadius: '1em',
                    padding: '2.5em',
                    maxWidth: '600px',
                    width: '100%',
                    position: 'relative',
                    maxHeight: '80vh',
                    overflow: 'auto'
                }}>
                    <button 
                        onClick={this.closeWebsiteSelectModal}
                        style={{
                            position: 'absolute',
                            top: '1em',
                            right: '1em',
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5em',
                            color: '#9197B3',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                    
                    <h3 style={{
                        fontSize: '1.6em',
                        fontWeight: '600',
                        color: '#252733',
                        marginBottom: '0.5em'
                    }}>
                        Выберите сайты для тарифа
                    </h3>

                    <div style={{
                        fontSize: '1.1em',
                        color: '#0767F4',
                        marginBottom: '1.5em',
                        fontWeight: '500'
                    }}>
                        {selectedTariff?.name} - {this.formatCurrency(billingPeriod === 'year' ? this.calculateYearlyPrice(selectedTariff?.price) : selectedTariff?.price)}/{billingPeriod === 'year' ? 'год' : 'мес'}
                    </div>

                    {loadingWebsites ? (
                        <div style={{textAlign: 'center', padding: '2em', color: '#666'}}>
                            Загрузка сайтов...
                        </div>
                    ) : websites.length === 0 ? (
                        <div style={{textAlign: 'center', padding: '2em', color: '#666'}}>
                            У вас нет добавленных сайтов. Добавьте сайт для подключения тарифа.
                        </div>
                    ) : (
                        <>
                            <div style={{
                                marginBottom: '1.5em',
                                color: '#666',
                                fontSize: '0.95em'
                            }}>
                                Выберите один или несколько сайтов, к которым хотите подключить данный тариф:
                            </div>

                            <div style={{
                                maxHeight: '300px',
                                overflow: 'auto',
                                marginBottom: '1.5em'
                            }}>
                                {websites.map(website => (
                                    <div 
                                        key={website.id}
                                        onClick={() => this.handleWebsiteToggle(website.id)}
                                        style={{
                                            padding: '1em',
                                            border: selectedWebsites.includes(website.id) ? '2px solid #0767F4' : '1px solid #E2ECF9',
                                            borderRadius: '0.5em',
                                            marginBottom: '0.8em',
                                            cursor: 'pointer',
                                            background: selectedWebsites.includes(website.id) ? '#FAFBFF' : 'white',
                                            transition: 'all 0.3s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div>
                                            <div style={{
                                                fontWeight: '600',
                                                color: '#252733',
                                                marginBottom: '0.3em'
                                            }}>
                                                {website.url}
                                            </div>
                                            <div style={{
                                                fontSize: '0.9em',
                                                color: '#666'
                                            }}>
                                                Макс. визитов: {website.monthly_visits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}/мес
                                            </div>
                                        </div>
                                        <div style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            border: '2px solid ' + (selectedWebsites.includes(website.id) ? '#0767F4' : '#E2ECF9'),
                                            background: selectedWebsites.includes(website.id) ? '#0767F4' : 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '0.8em',
                                            flexShrink: 0,
                                            marginLeft: '1em'
                                        }}>
                                            {selectedWebsites.includes(website.id) && '✓'}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div style={{
                                background: '#FFF3E0',
                                padding: '1em',
                                borderRadius: '0.5em',
                                marginBottom: '1.5em'
                            }}>
                                <div style={{
                                    fontSize: '0.9em',
                                    color: '#666'
                                }}>
                                    Выбрано сайтов: <strong>{selectedWebsites.length}</strong>
                                </div>
                            </div>

                            <div style={{display: 'flex', gap: '1em'}}>
                                <button 
                                    onClick={this.closeWebsiteSelectModal}
                                    style={{
                                        flex: 1,
                                        padding: '0.8em',
                                        border: 'none',
                                        borderRadius: '0.5em',
                                        background: '#9197B3',
                                        color: 'white',
                                        cursor: 'pointer',
                                        fontSize: '1em',
                                        fontWeight: '600'
                                    }}
                                >
                                    Отмена
                                </button>
                                <button 
                                    onClick={this.handleSubscribe}
                                    disabled={selectedWebsites.length === 0}
                                    style={{
                                        flex: 1,
                                        padding: '0.8em',
                                        border: 'none',
                                        borderRadius: '0.5em',
                                        background: selectedWebsites.length === 0 ? '#ccc' : '#0767F4',
                                        color: 'white',
                                        cursor: selectedWebsites.length === 0 ? 'not-allowed' : 'pointer',
                                        fontSize: '1em',
                                        fontWeight: '600'
                                    }}
                                >
                                    Подключить тариф
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { loading, selectedTariff, billingPeriod, tarificationMethod, showFreeTrialModal, tarifs } = this.state;

        return (
            <div className='createPage'>
                <h1>Тарифы</h1>
                <HorizontalLine />

                {/* Период оплаты */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '3em',
                    marginBottom: '1em'
                }}>
                    <div style={{
                        display: 'inline-flex',
                        background: '#F3F3F3',
                        borderRadius: '2em',
                        padding: '0.3em'
                    }}>
                        <button 
                            onClick={() => this.handleBillingPeriodChange('month')}
                            style={{
                                padding: '0.8em 2em',
                                border: 'none',
                                borderRadius: '2em',
                                background: billingPeriod === 'month' ? '#0767F4' : 'transparent',
                                color: billingPeriod === 'month' ? 'white' : '#666',
                                cursor: 'pointer',
                                fontSize: '1em',
                                fontWeight: '500',
                                transition: 'all 0.3s'
                            }}
                        >
                            Оплата помесячно
                        </button>
                        <button 
                            onClick={() => this.handleBillingPeriodChange('year')}
                            style={{
                                padding: '0.8em 2em',
                                border: 'none',
                                borderRadius: '2em',
                                background: billingPeriod === 'year' ? '#0767F4' : 'transparent',
                                color: billingPeriod === 'year' ? 'white' : '#666',
                                cursor: 'pointer',
                                fontSize: '1em',
                                fontWeight: '500',
                                transition: 'all 0.3s'
                            }}
                        >
                            Оплата за год
                            <span style={{
                                marginLeft: '0.5em',
                                background: '#39b339',
                                color: 'white',
                                padding: '0.2em 0.6em',
                                borderRadius: '1em',
                                fontSize: '0.8em'
                            }}>
                                -2 мес
                            </span>
                        </button>
                    </div>
                </div>

                {/* Тарифы */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '6em 4em', 
                    marginTop: '3em',
                    marginBottom: '7em'
                }}>
                    {tarifs.map(tarif => this.renderTarifCard(tarif))}
                </div>

                {/* Информация о тарификации */}
                <div className='editBlock' style={{marginTop: '5em'}}>
                    <div className='editBlock_name'>
                        <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                            Особенности тарификации
                        </h2>
                    </div>
                    
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '2em',
                        marginTop: '1.5em'
                    }}>
                        <div>
                            <div style={{
                                fontSize: '1.1em',
                                fontWeight: '600',
                                color: '#252733',
                                marginBottom: '0.8em'
                            }}>
                                Ежедневная тарификация
                            </div>
                            <div style={{color: '#666', lineHeight: '1.6'}}>
                                Тарификация осуществляется на ежедневной основе. Стоимость тарифа может меняться 
                                в зависимости от количества календарных дней, когда защита была активна.
                            </div>
                        </div>
                        
                        <div>
                            <div style={{
                                fontSize: '1.1em',
                                fontWeight: '600',
                                color: '#252733',
                                marginBottom: '0.8em'
                            }}>
                                Прозрачное списание
                            </div>
                            <div style={{color: '#666', lineHeight: '1.6'}}>
                                Сумму ежедневного списания исходя из тарифа уточняйте в личном кабинете.
                                Вы платите только за дни, когда защита была активна.
                            </div>
                        </div>
                    </div>
                </div>

                {/* Индивидуальные условия */}
                <div style={{
                    textAlign: 'center',
                    marginTop: '3em',
                    padding: '2em',
                    background: '#e8f4f8',
                    borderRadius: '1em'
                }}>
                    <div style={{
                        fontSize: '1.4em',
                        fontWeight: '600',
                        color: '#0767F4',
                        marginBottom: '0.5em'
                    }}>
                        Посещаемость вашего сайта больше 200 тыс визитов в месяц?
                    </div>
                    <div style={{
                        fontSize: '1.1em',
                        color: '#666',
                        marginBottom: '1em'
                    }}>
                        Напишите нам на <strong>info@clickanti.ru</strong>, мы обсудим индивидуальные условия.
                    </div>
                    <a 
                        href="mailto:info@clickfraud.ru"
                        className='btn1'
                        style={{
                            padding: '0.8em 2em',
                            textDecoration: 'none',
                            display: 'inline-block'
                        }}
                    >
                        Написать на почту
                    </a>
                </div>

                {/* Модальное окно выбора сайтов */}
                {this.renderWebsiteSelectModal()}

                {/* Модальное окно бесплатного теста */}
                {showFreeTrialModal && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '2em'
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '1em',
                            padding: '2.5em',
                            maxWidth: '500px',
                            width: '100%',
                            position: 'relative'
                        }}>
                            <button 
                                onClick={this.closeModal}
                                style={{
                                    position: 'absolute',
                                    top: '1em',
                                    right: '1em',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '1.5em',
                                    color: '#9197B3',
                                    cursor: 'pointer'
                                }}
                            >
                                ×
                            </button>
                            
                            <h3 style={{
                                fontSize: '1.6em',
                                fontWeight: '600',
                                color: '#252733',
                                marginBottom: '1em'
                            }}>
                                Бесплатный тест 7 дней
                            </h3>
                            
                            <div style={{color: '#666', lineHeight: '1.6', marginBottom: '1.5em'}}>
                                Для начала бесплатного теста вам необходимо:
                                <ol style={{paddingLeft: '1.5em', marginTop: '1em'}}>
                                    <li style={{marginBottom: '0.5em'}}>Выбрать подходящий тариф</li>
                                    <li style={{marginBottom: '0.5em'}}>Подключить сайт через панель управления</li>
                                    <li>Активировать защиту в настройках сайта</li>
                                </ol>
                            </div>
                            
                            <div style={{
                                background: '#FFF3E0',
                                padding: '1em',
                                borderRadius: '0.5em',
                                marginBottom: '1.5em'
                            }}>
                                <div style={{fontWeight: '600', color: '#F57C00', marginBottom: '0.3em'}}>
                                    ⚠️ Важно
                                </div>
                                <div style={{color: '#666', fontSize: '0.95em'}}>
                                    После окончания тестового периода подписка будет автоматически продлена 
                                    по выбранному тарифу. Вы можете отменить подписку в любой момент.
                                </div>
                            </div>
                            
                            <div style={{display: 'flex', gap: '1em'}}>
                                <button 
                                    onClick={this.closeModal}
                                    className='btn1'
                                    style={{
                                        flex: 1,
                                        padding: '0.8em',
                                        background: '#9197B3'
                                    }}
                                >
                                    Понятно
                                </button>
                                <button 
                                    onClick={() => {
                                        this.closeModal();
                                        this.handleSubscribe();
                                    }}
                                    className='btn1'
                                    style={{
                                        flex: 1,
                                        padding: '0.8em',
                                        background: '#0767F4'
                                    }}
                                >
                                    Начать тест
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const PaymentPageWrapper = () => {
    return <PaymentPage />;
};

export default PaymentPageWrapper;